import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import saveClient from "../functions/saveClientDetails";
import updateClientStatus from "../functions/updateClientStatus";


import { SessionContext } from "../context/session-context";

const useStyles = makeStyles({
    root: {
        paddingLeft:20,
    },
    textField:{
        width:'90%',
        maxWidth: 500,
        fontSize:12
    },
    clientButton:{
        width: 160,
        padding: 5,
        marginRight:20,
    },
    textItemFont:{
        fontSize:12
    }
});

var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };


export default function ClientForm(props) {
    const classes = useStyles();
    const [sState, sDispatch] = useContext(SessionContext);

    const [modelRows, setModelRows] = useState([]);

    const [isDisabled, setIsDisabled] = useState(true);
    const [companyName, setCompanyName] = useState('');
    const [companyID, setCompanyID] = useState(0);
    const [findID, setFindID] = useState(0);
    const [zohoID, setZohoID] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [county, setCounty] = useState('');
    const [country, setCountry] = useState('');
    const [postcode, setPostcode] = useState('');
    const [telephone, setTelephone] = useState('');
    const [status, setStatus] = useState('disabled');
    const [pricingModelID, setPricingModelID] = useState('');
    const [creditLimit, setCreditLimit] = useState(0);
    const [companyType, setCompanyType] = useState('standard');
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    const [companyLogo, setCompanyLogo] = useState('');
    const [exportFixedPrice, setExportFixedPrice] = useState(true);
    const [defaultSettings, setDefaultSettings] = useState({});

    useEffect(() => {
        getPricingLists();
    },[])

    useEffect(() => {

        if (props.client.companyid !== undefined){
            console.log("Default settings? ", JSON.stringify(props.client.defaultsettings));
            setCompanyID(props.client.companyid);
            setCompanyName(props.client.companyname)
            setFindID(props.client.findid);
            if (props.client.zohoid !== null) { setZohoID(props.client.zohoid); } else {setZohoID('');}
            setAddress1(props.client.address1);
            setAddress2(props.client.address2);
            setCity(props.client.city);
            setCounty(props.client.county);
            setCountry(props.client.country);
            setPostcode(props.client.postcode);
            if (props.client.telephone !== null) { setTelephone(props.client.telephone); } else {setTelephone('');}
            setStatus(props.client.status);
            setPricingModelID(props.client.pricemodelid);
            setCreditLimit(props.client.creditlimit);
            setCompanyType(props.client.ctype);
            (props.client.status === 'disabled' ) ? setIsDisabled(true) : setIsDisabled(false);
            setIsBtnDisabled(false);
            setDefaultSettings(props.client.defaultsettings);
            setCompanyLogo(props.client.defaultsettings.dprintlogo);
            setExportFixedPrice(props.client.defaultsettings.ddatafixedprice);
            
        }

        if (props.client.companyid === undefined){
            setStatus("active");
            setIsBtnDisabled(true);
        }


    },[props.client])

    const handleClientUpdate = () => {
        
        //Default Settings Obj
        defaultSettings.dprintlogo = companyLogo;
        defaultSettings.ddatafixedprice = exportFixedPrice;

        const client = {
            companyID:companyID,
            companyName:companyName,
            address1:address1,
            address2:address2,
            city:city,
            county:county,
            country:country,
            postcode:postcode,
            telephone:telephone,
            status:status,
            pricingModelID:pricingModelID,
            creditLimit:creditLimit,
            companyType:companyType,
            defaultsettings:defaultSettings,
            findID:findID,
            zohoID:zohoID
        }

        saveClient(client, sDispatch);
        props.updated();
    };

    const handleClientStatusUpdate = () => {

        let newStatus = 'active'
        if (status === 'active') { setStatus('disabled'); newStatus = 'disabled'; setIsDisabled(true); } else { setStatus('active'); newStatus = 'active'; setIsDisabled(false); }

        const client = {
            companyID:props.client.companyid,
            companyName:props.client.companyname,
            status:newStatus
        }
        updateClientStatus(client, sDispatch);
        props.updated();
    };

    const getPricingLists = () =>{

        const abortController = new AbortController();

        let mounted = true;
        (async () => {  
          const res = await fetch(process.env.REACT_APP_FIND_API+'/admin/pricingmodel', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            signal: abortController.signal,
          }).catch(handleError);
          const data = await res.json();
          if (mounted) {
            if (data.status === "success"){
                setModelRows(data.data);
            } else {
                setModelRows([]);
            }
          }
          const cleanup = () => {
            mounted = false;
            abortController.abort();
          };
          return cleanup;
      
      })();
    }

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12}>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="companyName" label="Company Name" size="small" margin="dense" variant="outlined" value={status === 'active'?companyName:companyName+" (Disabled)"} onChange={e => setCompanyName(e.target.value)} disabled={isDisabled}/>  
                </Grid>
                <Grid item xs={8}>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="address1" label="Address 1" size="small" margin="dense" variant="outlined" value={address1} onChange={e => setAddress1(e.target.value)} disabled={isDisabled}/> 
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="address2" label="Address 2" size="small" margin="dense" variant="outlined" value={address2} onChange={e => setAddress2(e.target.value)} disabled={isDisabled}/> 
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="city" label="City" size="small" margin="dense" variant="outlined" value={city} onChange={e => setCity(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="county" label="County" size="small" margin="dense" variant="outlined" value={county} onChange={e => setCounty(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="country" label="Country" size="small" margin="dense" variant="outlined" value={country} onChange={e => setCountry(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="postcode" label="Postcode" size="small" margin="dense" variant="outlined" value={postcode} onChange={e => setPostcode(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="telephone" label="Telephone" size="small" margin="dense" variant="outlined" value={telephone} onChange={e => setTelephone(e.target.value)} disabled={isDisabled}/>
                </Grid>
                <Grid item xs={4}>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="findID" label="Account ID" size="small" margin="dense" variant="outlined" value={findID} onChange={e => setFindID(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="zohoID" label="Zoho ID" size="small" margin="dense" variant="outlined" value={zohoID} onChange={e => setZohoID(e.target.value)} disabled={isDisabled}/> 
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} defaultValue="standard" name="pricingModel" label="Pricing Model" size="small" margin="dense" variant="outlined" value={pricingModelID} onChange={e => setPricingModelID(e.target.value)} disabled={isDisabled} select>
                        {modelRows.map((item, i) => (
                            <MenuItem key={i} value={item.modelid}>{item.name}</MenuItem>
                        ))}
                    </TextField>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="companyType" defaultValue="standard" label="Company Type" size="small" margin="dense" variant="outlined" value={companyType} onChange={e => setCompanyType(e.target.value)} disabled={isDisabled} select>
                        <MenuItem value={'standard'}>Standard</MenuItem>
                        <MenuItem value={'standard_dxf'}>Standard - DXF export</MenuItem>
                        <MenuItem value={'standard_shp'}>Standard - SHP export</MenuItem>
                        <MenuItem value={'view‑only'}>View‑only</MenuItem>
                        <MenuItem value={'gia'}>GIA</MenuItem>
                        <MenuItem value={'agent'}>Estate Agent</MenuItem>
                        <MenuItem value={'consultancy'}>Internal Consultancy</MenuItem>
                        <MenuItem value={'architecture'}>Architecture</MenuItem>
                        <MenuItem value={'training'}>Training</MenuItem>
                    </TextField>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="exportFixedPrice" defaultValue="standard" label="Use fixed export pricing?" size="small" margin="dense" variant="outlined" value={exportFixedPrice} onChange={e => setExportFixedPrice(e.target.value)} disabled={isDisabled} select>
                        <MenuItem value={true}>True</MenuItem>
                        <MenuItem value={false}>False</MenuItem>
                    </TextField>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="creditLimit" label="Credit Limit" size="small" margin="dense" variant="outlined" value={creditLimit} onChange={e => setCreditLimit(e.target.value)} disabled={isDisabled}/>
                    <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="companyLogo" label="Company Logo" size="small" margin="dense" variant="outlined" value={companyLogo} onChange={e => setCompanyLogo(e.target.value)} disabled={isDisabled}/> 
                </Grid>
                <Grid item xs={12}>
                    <Button className={classes.clientButton} variant="contained" onClick={handleClientUpdate} disabled={isDisabled}>
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Update</Box>
                    </Button>
                    <Button className={classes.clientButton} variant="contained" onClick={handleClientStatusUpdate} disabled={isBtnDisabled}>
                    {status === 'active' ? (
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Disable Client</Box>
                    ) : ( 
                        <Box fontWeight="fontWeightRegular" fontSize={12} >Enable Client</Box>
                    )}
                    </Button>                    
                </Grid>
            </Grid>
        </div>
    )
  };
